/**
 * Schedule Page — Public route wrapper for SignupRequestView
 *
 * Reads marketSlug from URL params and intentCode from ?c= query param,
 * then renders the SignupRequestView component inside the site-wide
 * branded layout shell (Header + Footer).
 *
 * Route: /schedule/:marketSlug
 *
 * @story SCRUM-1466 — 0.1.1.8-03: SignupRequestView Frontend
 * @story SCRUM-1596 — Public schedule page branding
 */

import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import SignupRequestView from '../../components/llac/SignupRequestView';

export default function SchedulePage() {
  const { marketSlug } = useParams();
  const [searchParams] = useSearchParams();
  const intentCode = searchParams.get('c') || undefined;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1 }}>
        <SignupRequestView marketSlug={marketSlug} intentCode={intentCode} />
      </main>
      <Footer />
    </div>
  );
}
